import { render, staticRenderFns } from "./can.vue?vue&type=template&id=f939c4ca"
import script from "./can.vue?vue&type=script&lang=js"
export * from "./can.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports